import React from "react";
import "./WhatsAppPopup.css";

const WhatsAppPopup = () => {
  return (
    <div className="whatsapp-container">
      <a
        href="https://wa.me/917775091222"  // Replace with your number
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
};

export default WhatsAppPopup;
